export enum LanguagesEnum
{
    en = "en",
    nl = "nl",
    fr = "fr",
    de = "de",
    it = "it",
    es="es"
}
